import React, { useState, useEffect } from "react";
import styles from './Menu.module.less';
import classNames from "classnames";
const keyboardSymbols = {
    alt: '⌥',
    ctrl: '⌃',
    meta: '⌘',
    shift: '⇧',
    delete: '⌦',
    backspace: '⌫',
    escape: '␛',
    equal: '=',
    minus: '−',
    backslash: '\\',
    slash: '/',
    comma: ',',
    period: '.',
    quote: '"',
    backquote: '`',
    semicolon: ';',
    bracketleft: '[',
    bracketright: ']',
    arrowup: '↑',
    arrowright: '→',
    arrowdown: '↓',
    arrowleft: '←'
};
export function findKeyBinding(id, shortcuts) {
    return shortcuts?.find(({ command }) => command === id)?.key
        .split('+')
        .map(key => (keyboardSymbols[key] ?? key).toUpperCase())
        .join(' ');
}
export function Menu({ items, shortcuts, click = (id) => { } }) {
    const [checklist, setCheckList] = useState(false);
    useEffect(() => {
        setCheckList(items.some(({ checked }) => checked !== undefined));
    }, [items]);
    const [menuItems, setMenuItems] = useState([]);
    useEffect(() => {
        setMenuItems(items.map(item => ({ ...item, shortcut: item.shortcut ?? findKeyBinding(item.id, shortcuts ?? []) })));
    }, [items]);
    return React.createElement("ul", { className: classNames('dry-menu', styles.root, { checklist }) }, menuItems.map(item => React.createElement("li", { key: item.id, className: classNames({
            [styles.separator]: item.separator,
            checked: item.checked === true
        }, item.className), onMouseDown: e => {
            const stopPropagation = item.click ? item.click() : click(item.id);
            if (typeof stopPropagation === 'boolean') {
                stopPropagation === true && e.stopPropagation();
            }
            else if (typeof item.checked === 'boolean') {
                e.stopPropagation();
            }
        } },
        React.createElement("span", null,
            item.checked === true &&
                React.createElement("svg", { viewBox: "0 -960 960 960" },
                    React.createElement("path", { d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" })),
            item.label),
        React.createElement("span", null, item.shortcut))));
}
